// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1931":"f1afa044faebd4a0","3185":"5f27b638a515eebf"}[chunkId] + ".css";
};